import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const COLUMN_ORDER_ASSET_CLASS_DATA = "assetClass";
export const COLUMN_ORDER_STATE_DATA: string = "orderState";
export const COLUMN_SELECTION_DATA: string = "selection";
export const COLUMN_ORDER_ID_DATA: string = "orderId";
export const COLUMN_STATUS_DATA: string = "fillState";
export const COLUMN_CLIENT_NAME_DATA: string = "clientName";
export const COLUMN_CLIENT_ID_DATA: string = "clientCode";
export const COLUMN_DEALT_DIR_DATA: string = "clientIntent";
export const COLUMN_ACCOUNT_NAME_DATA: string = "accountName";
export const COLUMN_INSTRUMENT_DATA: string = "instrument";
export const COLUMN_ACCOUNT_ID_DATA: string = "accountCode";
export const COLUMN_ORDER_AMOUNT_DATA: string = "orderQty";
export const COLUMN_ORDER_FIXING_SOURCE_CODE_DATA: string = "fixingSourceCd";
export const COLUMN_TRADE_ORDER_TYPE_DATA: string = "requestedOrderType";
export const COLUMN_TRADE_ORDER_PRODUCT_DATA: string = "productType";
export const COLUMN_ORDER_PRODUCT_PRODUCT: string = "product";
export const COLUMN_INTER_ORDER_PRODUCT: string = "product";
export const COLUMN_TRADE_VALUE_DATE_DATA: string = "settleDate";
export const COLUMN_VALUE_DATE: string = "settleDate";
export const COLUMN_DEALT_CURRENCY_DATA: string = "fixedCode";
export const COLUMN_DESK_ID_DATA: string = "deskId";
export const COLUMN_TRADE_CLIENT_TRADER_DATA: string = "clientTraderName";
export const COLUMN_TRADE_SALES_GROUP_ID_DATA: string = "salesGroupId";
export const COLUMN_ORDER_USD_AMOUNT_DATA: string = "usdEquivQty";

export const COLUMN_TRADE_DESK_ID: string = "traderGroupId";
export const COLUMN_INTER_DESK_ID: string = "traderGroupId";
export const COLUMN_ORDER_TYPE: string = "requestedOrderType";

export enum BenchmarkProductTypes {
  SPT,
  FWD,
  SWP,
  SSP,
}

export type BMARKProductValues = {
  [key in Exclude<CubiqTS.Product, CubiqTS.Product.NDF>]?: string;
};

// CLASS NAMES
export const BLOTTER_PRIORITY_COLUMN_CLASS_NAME: string = "blotter_priority_col";
export const BLOTTER_PRIMARY_COLUMN_CLASS_NAME: string = "blotter_primary_col";

export const REQUESTED_FIXING_TIME_COLUMN_PROPERTY = "reqFixingTime";
export const REQUESTED_FIXING_DATE_COLUMN_PROPERTY = "reqFixingDate";
export const REQUESTED_FIXING_TIMEZONE_COLUMN_PROPERTY = "reqFixingTzCd";
export const FIXING_DATE_COLUMN_PROPERTY = "fixingDate";
export const MOMENT_DATE_FORMAT_STRING = "YYYY-MM-DD HH:mm:ss.SSS";
export const FIXING_DATE_UTC_FORMAT = "HH:mm DD-MMM-YYYY";
export const TIME_ZONE_UTC = "UTC";
export const BMARK_DEFAULT_NAME = "BM";
